export default __webpack_public_path__ + "static/media/img_3.8f1e4bfb.jpg";